import { Avatar, Skeleton } from '@mui/material'
import { useQuery } from '@tanstack/react-query'
import { qk } from 'api'
import { getMyProfile } from 'api/users'

export const MyAvatar = ({ size }: { size: number }) => {
  const { data, isLoading } = useQuery(
    qk.users.myProfile.toKey(),
    getMyProfile,
    { staleTime: Number.POSITIVE_INFINITY },
  )

  const initials = data ? data.fullName.slice(0, 2).toUpperCase() : undefined

  const imageSrc = data?.avatarUrl

  if (isLoading) {
    return <Skeleton variant="circular" width={size} height={size} />
  }

  if (!imageSrc) {
    return (
      <Avatar
        sx={{
          bgcolor: theme => theme.palette.primary.main,
          opacity: 0.8,
          width: size,
          height: size,
          fontSize: '16px',
        }}
      >
        {initials}
      </Avatar>
    )
  }

  return <Avatar src={imageSrc} sx={{ width: size, height: size }} />
}
